const controllers = new Map();

export function acquireAbortController(key) {
  if (controllers.has(key)) {
    console.warn("[ABORT]", key);
    controllers.get(key).abort();
  }

  const controller = new AbortController();
  controllers.set(key, controller);

  return controller;
}

export function releaseAbortController(key, controller) {
  // Only delete if this is still the current controller for this key.
  // A stale call's finally block must not evict a newer controller.
  if (controllers.get(key) === controller) {
    controllers.delete(key);
  }
}

// Legacy aliases kept for any callers that haven't been updated yet.
export const acquireAbortSignal = acquireAbortController;
export const releaseAbortSignal = releaseAbortController;

export function abortAll() {
  controllers.forEach((controller) => controller.abort());
  controllers.clear();
}
